import React, { useState } from "react";
import MainCalculatorsList from './MainCalculators';
import SharedHelmet from '.././Helmet';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة مكرر الربحية - حساب مكرر الربحية للشركات";
const DESCRIPTION =
    "حاسبة مكرر الربحية تقوم بحساب مكرر الربحية الخاص بالشركات بناءً على القيمة السوقية للسهم وربحية السهم.";
const KEYWORDS = "مكرر الربحية, حساب مكرر الربحية, حاسبة مكرر الربحية";
const OG_URL = "https://do-calculate.com/calculator/ar/pe-ratio";
function Calculator() {
    const [stockPrice, setStockPrice] = useState('');
    const [earningsPerShare, setEarningsPerShare] = useState('');
    const [peRatio, setPeRatio] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!stockPrice || !earningsPerShare) {
            setError('الرجاء إدخال سعر السهم وربحية السهم بشكل صحيح');
            setPeRatio('');
            return;
        }
        const stockPriceValue = parseFloat(stockPrice);
        const earningsPerShareValue = parseFloat(earningsPerShare);
        if (isNaN(stockPriceValue) || isNaN(earningsPerShareValue) || earningsPerShareValue <= 0) {
            setError('الرجاء إدخال قيم صحيحة وإيجابية لسعر السهم وربحية السهم');
            setPeRatio('');
            return;
        }
        const peRatioValue = stockPriceValue / earningsPerShareValue;
        setPeRatio(peRatioValue.toFixed(2));
        setError('');
    };
    return (
        <div className="rtl">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                <h2 style={{ fontSize: '18px' }}>طريقة حساب مكرر الربحية </h2>
                                <p>
                                    طريقة حساب مكرر الربحية تتمثل في المعادلة الحسابيّة الآتية:
                                </p>
                                <p>
                                    مكرر الربحية = القيمة السوقيّة للسهم الواحد ÷ ربحية السهم
                                </p>
                                <p>
                                    يستخدم مكرر الربحية لاحتساب أرباح أسهم الشركات المختلفة، ويشير إلى أداء الشركة خلال 12 شهراً.
                                </p>
                                <hr />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-7 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                </div>
                                <hr />
                                <div dir="rtl">
                                    <div>
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label className="form-label ms-2">سعر السهم</label>
                                            </b>
                                            <input
                                                type="number"
                                                placeholder="139.55"
                                                value={stockPrice}
                                                onChange={(e) => setStockPrice(e.target.value)}
                                                className="form-control"
                                                style={{ width: '150px' }}
                                            />
                                        </div>
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label className="form-label ms-2">ربحية السهم</label>
                                            </b>
                                            <input
                                                type="number"
                                                placeholder="4.75"
                                                value={earningsPerShare}
                                                onChange={(e) => setEarningsPerShare(e.target.value)}
                                                className="form-control"
                                                style={{ width: '150px' }}
                                            />
                                        </div>
                                        <br />
                                        <button
                                            className="btn btn-success"
                                            style={{ fontSize: '20px' }}
                                            onClick={handleCalculate}
                                        >
                                            احسب مكرر الربحية
                                        </button>
                                    </div>
                                    <br />
                                    <div>
                                        {error !== '' ? (
                                            <p className='p-3 mb-2 bg-warning text-white'>خطأ: {error}</p>
                                        ) : (
                                            <>
                                                {peRatio !== '' && (
                                                    <>
                                                        <p className='p-3 mb-2 bg-success text-white'>
                                                            مكرر الربحية: {peRatio}
                                                        </p>
                                                        <p className='p-3 mb-2 bg-info text-black'>
                                                            خطوات الحل: <br />
                                                            - قم بقسمة سعر السهم على ربحية السهم للحصول على مكرر الربحية.
                                                        </p>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={500}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="col-12 col-md-8">
                <div className="info-sections-container">
                    <div className="info-section">
                        <div className="info-section-header">
                            <h2 style={{ fontSize: "18px" }}>{TITLE}</h2>
                        </div>
                        <div className="info-section-body">
                            <p>{DESCRIPTION}</p>
                            <div>
                                <h3 style={{ fontSize: '16px' }}>كيف يتم حساب مكرر الربحية؟</h3>
                                <p>يتم حساب مكرر الربحية باستخدام الصيغة التالية:</p>
                                <p><strong>مكرر الربحية = القيمة السوقية للسهم ÷ ربحية السهم</strong></p>
                                <p>مكرر الربحية هو مقياس يُستخدم لتقييم سعر السهم بناءً على أرباح الشركة. يعكس هذا المعدل مدى تقييم السوق لربحية الشركة خلال فترة زمنية معينة، وعادة ما تكون سنة.</p>
                            </div>
                            <hr />
                            <div>
                                <h3 style={{ fontSize: '16px' }}>كيفية استخدام حاسبة مكرر الربحية</h3>
                                <p>لاستخدام حاسبة مكرر الربحية، أدخل القيم التالية:</p>
                                <ul>
                                    <li><strong>القيمة السوقية للسهم:</strong> السعر الحالي للسهم في السوق.</li>
                                    <li><strong>ربحية السهم:</strong> الأرباح الصافية للشركة مقسومة على عدد الأسهم القائمة.</li>
                                </ul>
                                <p>بعد إدخال هذه القيم، ستقوم الحاسبة بحساب نسبة مكرر الربحية تلقائيًا، مما يساعدك في تقييم مدى جاذبية السهم مقارنةً بالأرباح التي يحققها.</p>
                            </div>
                            <hr />
                            <div>
                                <h3 style={{ fontSize: '16px' }}>مثال على حساب مكرر الربحية</h3>
                                <p>لنفترض أن القيمة السوقية للسهم هي 50 دولارًا وربحية السهم هي 5 دولارات. نستخدم الصيغة التالية:</p>
                                <div className='p-3 mb-2 bg-info'>
                                    <strong>مكرر الربحية = القيمة السوقية للسهم ÷ ربحية السهم = 50 دولار ÷ 5 دولارات = 10</strong>
                                </div>
                                <p>بالتالي، مكرر الربحية في هذا المثال هو 10. يعني ذلك أن المستثمر يدفع 10 دولارات مقابل كل دولار من الأرباح التي تحققها الشركة.</p>
                            </div>
                            <hr />
                            <div>
                                <h3 style={{ fontSize: '16px' }}>نصائح حول حساب مكرر الربحية</h3>
                                <p>للحصول على تقييم دقيق، تأكد من استخدام القيم الصحيحة لكل من القيمة السوقية للسهم وربحية السهم. كما ينبغي ملاحظة أن مكرر الربحية قد يختلف بناءً على القطاع الصناعي وظروف السوق. لمزيد من المعلومات حول استخدام مكرر الربحية في التحليل المالي، يمكنك الاطلاع على المصادر التالية، التي استخدمناها في تطوير هذه الحاسبة:</p>
                                <ul>
                                    <li><a href="https://www.investopedia.com/terms/p/price-earningsratio.asp" rel="nofollow noreferrer" target="_blank">Investopedia - Price-to-Earnings Ratio</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Calculator;
